<template>
    <div>
        <base-crud
                crudName="Categorias de Temas"
                newText="Nova Categoria"
                :table="themeCategoryTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="true"
                :enableEdit="true"
                :enableDelete="true"
                :enableView="false"
        >
        </base-crud>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function() {
    return {
      themeCategoryTable: "themeCategoryTable",
      teams: [],
      pages: [],
      url: "",
      columns: ["id", "description","color", "actions"],
      tableData: ["id", "description","color"],
      options: {
        filterable:["id", "description"],
        filterByColumn: true,                   
        sortable: ["id", "description"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          description: "Descrição",
          actions: "Ações"
        },
        requestFunction: function(data) {
          let requestData = {};

           let query = this.$parent.$parent.query(data.query);
           requestData.params = data;
           requestData.params.query = "";
           requestData.params.with = [];

          return this.$http
              .get(this.url + '?' + query, requestData)
              .catch(
                  function(e) {
                      this.dispatch("error", e);
                  }.bind(this)
              );
        }
      },
      endPoint: "theme-categories/"
    };
  },
  methods: {
    query: function (query) {
      let columns = {
        id: 'id',
        description: 'description',
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    }
  },
  components: {
    BaseCrud
  }
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ThemeCategory/Crud.vue